import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=accc41fc&scoped=true&"
import script from "./Heading.vue?vue&type=script&lang=js&"
export * from "./Heading.vue?vue&type=script&lang=js&"
import style0 from "./Heading.vue?vue&type=style&index=0&id=accc41fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc41fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('accc41fc')) {
      api.createRecord('accc41fc', component.options)
    } else {
      api.reload('accc41fc', component.options)
    }
    module.hot.accept("./Heading.vue?vue&type=template&id=accc41fc&scoped=true&", function () {
      api.rerender('accc41fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Heading.vue"
export default component.exports